import { style } from "glamor";

export const styles = style({
    " .view-group:first-of-type": {
        borderBottom: "1px solid gray",
    },
});
